import React from "react"

import { InputDigits } from "@atos6/components"
import { digitsOnly } from "@atos6/utils"
import { useStore } from "../containers"

export function InputAgencyStateful() {
  const { agency, setState } = useStore()

  return (
    <InputDigits
      placeholder="Agência"
      maxLength={4}
      value={digitsOnly(agency)}
      onChange={agency => setState({ agency })}
    />
  )
}
